/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1PersonId202,
  PutApiV1PersonId400,
  PutApiV1PersonId401,
  PutApiV1PersonId404,
  PutApiV1PersonId409,
  PutApiV1PersonId500,
  PutApiV1PersonIdMutationRequest,
  PutApiV1PersonIdMutationResponse,
  PutApiV1PersonIdPathParams,
} from "../../types/personRegisterController/PutApiV1PersonId.ts";
import { updatePersonRequestViewModelSchema } from "../updatePersonRequestViewModelSchema.ts";

export const putApiV1PersonIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1PersonIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1PersonId202Schema =
  z.any() as unknown as ToZod<PutApiV1PersonId202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1PersonId400Schema =
  z.any() as unknown as ToZod<PutApiV1PersonId400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1PersonId401Schema =
  z.any() as unknown as ToZod<PutApiV1PersonId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1PersonId404Schema =
  z.any() as unknown as ToZod<PutApiV1PersonId404>;

/**
 * @description (Conflict) Há um conflito com os dados existentes.
 */
export const putApiV1PersonId409Schema =
  z.any() as unknown as ToZod<PutApiV1PersonId409>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1PersonId500Schema =
  z.any() as unknown as ToZod<PutApiV1PersonId500>;

export const putApiV1PersonIdMutationRequestSchema = z.lazy(
  () => updatePersonRequestViewModelSchema,
) as unknown as ToZod<PutApiV1PersonIdMutationRequest>;

export const putApiV1PersonIdMutationResponseSchema = z.lazy(
  () => putApiV1PersonId202Schema,
) as unknown as ToZod<PutApiV1PersonIdMutationResponse>;
